/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderSchema } from "./mobileOrderSchema.ts";

export const orderByPosIdRetrievePathPosIdSchema = z.uuid();

export const orderByPosIdRetrieveStatus200Schema = mobileOrderSchema;

export const orderByPosIdRetrieveResponseSchema = orderByPosIdRetrieveStatus200Schema;
